const MIRA_PROD_URL = 'https://mira.fiverr.com';
const MIRA_DEV_URL = 'https://recruiter.f-labs.dev';
const MIRA_ENTRY_PATH = '/api/v1/entry/start';

const isProductionHost = (hostname: string): boolean => hostname.endsWith('.fiverr.com') && !hostname.includes('.dev.');

export interface MiraSearchParams {
    source: string;
    prompt?: string;
    [key: string]: string | undefined;
}

const resolveMiraUrl = (searchParams?: MiraSearchParams): string => {
    if (typeof window === 'undefined') {
        return '';
    }

    const isProd = isProductionHost(window.location.hostname);

    const baseUrl = isProd ? MIRA_PROD_URL : MIRA_DEV_URL;

    const miraUrl = new URL(MIRA_ENTRY_PATH, baseUrl);

    Object.entries(searchParams ?? {}).forEach(([key, value]) => {
        if (value) {
            miraUrl.searchParams.set(key, value);
        }
    });

    return miraUrl.toString();
};

export const getMiraRecruiterEntry = (searchParams?: MiraSearchParams) => {
    const miraUrl = resolveMiraUrl(searchParams);

    const openMiraTab = () => {
        if (!miraUrl) {
            return;
        }

        window.open(miraUrl, '_blank', 'noopener');
    };

    return { miraUrl, openMiraTab };
};
